import { render, staticRenderFns } from "./widget-list-row-header.vue?vue&type=template&id=10c0c148"
import script from "./widget-list-row-header.vue?vue&type=script&lang=js"
export * from "./widget-list-row-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports